export default __webpack_public_path__ + "static/media/art-red-poster-3.496b6619.jpg";